const withUpmId = (url: string, upmId?: string) =>
  upmId ? `${url}?upmId=${encodeURIComponent(upmId)}` : url

export const getMenusUrl = (upmId?: string) => withUpmId('/hproduce-features/menus', upmId)
export const postSelectPersonaUrl = () => '/hproduce-features/menus'
export const getPersonaUrl = () => '/hproduce-features/menu-presets/summaries'
export const getActivePersonaUrl = () => '/hproduce-features/menus/initial-preset'
export {getPlantHierarchyUrl} from '@hproduce/suite-core'
export const getUserUrl = (userId: string) => `/users/${userId}`
export const getFeaturesUrl = (upmId?: string) => withUpmId('/hproduce-features/features', upmId)

export const PO_CONTACT_EMAIL: string = 'daniil.starikov@heidelbergmaterials.com'
